import { render, staticRenderFns } from "./ProductOverviewPagination.vue?vue&type=template&id=65eb4ec8&scoped=true"
import script from "./ProductOverviewPagination.vue?vue&type=script&lang=js"
export * from "./ProductOverviewPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb4ec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65eb4ec8')) {
      api.createRecord('65eb4ec8', component.options)
    } else {
      api.reload('65eb4ec8', component.options)
    }
    module.hot.accept("./ProductOverviewPagination.vue?vue&type=template&id=65eb4ec8&scoped=true", function () {
      api.rerender('65eb4ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductOverviewPagination.vue"
export default component.exports